<script>
import forminput from "../formcomponet/forminput.vue"; 
import formcombobox from "../formcomponet/formcombobox.vue";
import formtextarea from "../formcomponet/formtextarea.vue";
import formcheckbox from "../formcomponet/formcheckbox.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import documents from "@/models/documents";
import vue2Dropzone from "vue2-dropzone";
import appConfig from "@/app.config";
 
export default {
  mixins: [apibtoast, apigeneric, documents,appConfig],
  props: ["Id", "AddEdit"],
  data() { 
    return {

      FormData: {},
      dropzoneOptions: {
        url: process.env.VUE_APP_API_URL+"GenericFileUpDownload/UploadFile?pathUrl=Web",
        thumbnailWidth: 100,
        thumbnailHeight:100,
        maxFilesize: 2,
        addRemoveLinks: true,
        autoProcessQueue:false,
        headers: { "My-Awesome-Header": "header value" }
      },
      filelist:[],
      filelistjson:[],
      visible: false,
      singleImage: false,
      visibleCaption: false,
      index: 0, // default: 0
      files: [],
      dosya_eklendi:0,
      kayit_tipleri: [
          { Id:"1",  Value:"Klasör" },
          { Id:"2",  Value:"Dosya" },  
      ]
  
    };
  },
  components: {
    Loader,
    forminput, 
    formcombobox,
    formcheckbox,
    formtextarea,
    vue2Dropzone,


  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.filelist=[];
      this.filelistjson=[];
      this.files=[];
       if (this.AddEdit == "Edit") {

         if (this.FormData.filepath!=null){
        
        this.filelistjson=JSON.parse(this.FormData.filepath);

         this.filelist = JSON.parse(this.FormData.filepath);
         }
            
            if (this.filelist!=null && this.filelist!=""){     

              for (var i=0; i<this.filelist.length;i++){

               // this.files.push( process.env.VUE_APP_FILES_URL+"web/"+this.filelist[i].file_link);

                this.filelist[i].file_link= process.env.VUE_APP_FILES_URL+"web/"+this.filelist[i].file_link;

              }

              this.files=this.filelist;

            }

    
       }


    },


  },
  methods: {
    onSubmit() {
       
        this.FormData.Websiteid="34a035fe-de82-406b-a444-9cf9140bcd81";


      this.$v.$touch();
      if (!this.$v.$invalid) {  


        if (this.dosya_eklendi==1){
         this.dosyalari_yukle();
        } else{

            if (this.AddEdit == "Add") {
                  
              this.Post("documents", this.FormData).then((res) => {
                if (res) {
                    this.$emit("TableUpdate");
                    this.$bvModal.hide("documents"); 
                }
              });

            } else {

              this.FormData.filepath=JSON.parse(this.FormData.filepath);

              this.FormData.Id=this.FormData.id;
              this.Update("documents", this.FormData).then((res) => {
                if (res) {
                
                  this.$emit("TableUpdate");
                  this.$bvModal.hide("documents");
                }
              });
            }
        }
      }
    },

    afterUploadComplate: async  function(response){

      let gelen=JSON.parse(JSON.parse(response.xhr.response));
      let file_name=response.upload.filename;
      let file_link=gelen.Data.filename;
      let file_type= file_link.substring(file_link.lastIndexOf('.')+1, file_link.length) || file_link;

      this.filelistjson.push({ "file_link": file_link, "file_name": file_name, "file_type":file_type })


      this.FormData.filepath=this.filelistjson;


       this.filelist = this.filelistjson;

       this.files=[];

        for (var i=0; i<this.filelist.length;i++){
          
          this.filelist[i].file_link= process.env.VUE_APP_FILES_URL+"web/"+this.filelist[i].file_link;

        }

        this.files=this.filelist;


    },

    afterUploadAllComplate(){

                if (this.AddEdit == "Add") {
                  
              this.Post("Documents", this.FormData).then((res) => {
                if (res) {
                    this.$emit("TableUpdate");
                    this.$bvModal.hide("Documents"); 
                    this.dosya_eklendi=0;
                }
              });

            } else {

              this.FormData.Id=this.FormData.id;

              this.Update("Documents", this.FormData).then((res) => {
                if (res) {
                
                  this.$emit("TableUpdate");
                  this.$bvModal.hide("Documents");
                  this.dosya_eklendi=0;
                }
              });
            }

      
     
    },

    vfileAdded(file) {
        this.dosya_eklendi=1;
        console.log(file.name);
    },

    dosyalari_yukle(){

      this.$refs.myVueDropzone.processQueue();    

    },
    
    handleHide() {
      this.visible = false;
    },
    showCaptiomImg(index) {
      this.index = index;
      this.visibleCaption = true;
    },
    handleCaptionHide() {
      this.visibleCaption = false;
    },

    dosya_sil(index){
      
       this.filelist = JSON.parse(this.FormData.filepath);

       this.files=[];
        this.filelist.splice(index,1);
         this.FormData.filepath=JSON.stringify(this.filelist);

              for (var i=0; i<this.filelist.length;i++){

         
                this.filelist[i].file_link= process.env.VUE_APP_FILES_URL+"web/"+this.filelist[i].file_link;

              }

              this.files=this.filelist;

    },

    Get() {}, 

    tip_kontrol(){
          this.FormDataType.Typeid.ComboDataArray=[];
    for (var i = 0; i < this.kayit_tipleri.length; i++) {

      if(this.FormData.topid==null || this.FormData.topid==""){
    
      this.FormDataType.Typeid.ComboDataArray.push({
        Id: this.kayit_tipleri[i].Id,
        Value: this.kayit_tipleri[i].Value,
      });

      } else {

        if (this.kayit_tipleri[i].Id==2){
          this.FormDataType.Typeid.ComboDataArray.push({
            Id: this.kayit_tipleri[i].Id,
            Value: this.kayit_tipleri[i].Value,
          });
        }

      }
    }   
    }
  },
};
</script>
<template>
  <Loader>


    <b-modal
      id="documents"
      size="xl"
      :title="
        this.AddEdit == 'Edit'
          ? $t('documents.AddEdit.FormTitleEdit')
          : $t('documents.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >  

      <Form @submit.prevent="onSubmit"> 


      <div class="row">
          <div class="col-md-6">

               <formcombobox
                  :FormDataType="FormDataType.Topid"
                  :Value="FormData.topid"
                  :v="$v.FormData.topid"
                  @input="FormData.topid = $event"
            /> 
           
          </div>
          
        </div>

        <div class="row">
          <div class="col-md-6">

              <forminput
                :FormDataType="FormDataType.Dataorder"
                :Value="FormData.dataorder"
                :v="$v.FormData.dataorder"
                @input="FormData.dataorder = $event"
              /> 
           
          </div>
          
        </div>
         <div class="row">
          <div class="col-md-6">

                <formcombobox
                  :FormDataType="FormDataType.Typeid"
                  :Value="FormData.typeid"
                  :v="$v.FormData.typeid"
                  @input="FormData.typeid = $event"
            /> 
           
          </div>
          
        </div>
        <div class="row">
          <div class="col-md-12">

               <forminput
                :FormDataType="FormDataType.Title"
                :Value="FormData.title"
                :v="$v.FormData.title"
                @input="FormData.title = $event"
              /> 
           
          </div>
          
        </div>
        <div class="row">
          <div class="col-md-12">

            <formtextarea
              :FormDataType="FormDataType.Description"
              :Value="FormData.description"
              :v="$v.FormData.description"
              @input="FormData.description = $event"
            />
           
          </div>
          
        </div>
          <div class="row">
          <div class="col-md-6">
            <formcheckbox
              :title_position="'mb-3'"
              :labels_lg="2"
              :FormDataType="FormDataType.Approval"
              :Value="FormData.approval"
              :v="$v.FormData.approval"
              @input="FormData.approval = $event"
            />
          </div>
        </div>

<br>
           <h4>{{this.$t('documents.AddEdit.Filepath')}}</h4>
<hr/>


          <div class="row">
          <div class="col-md-12">
            <b-form-group
              :class="title_position"
              :label-cols-lg="labels_lg"
              id="example text"
             
              label-for="text"
            >  
              <vue2Dropzone
              id="myVueDropzone"
              ref="myVueDropzone"
              :use-custom-slot="true"
              :options="dropzoneOptions"
              @vdropzone-file-added="vfileAdded"
              @vdropzone-complete="afterUploadComplate"
              @vdropzone-queue-complete="afterUploadAllComplate"
                   
            >
              <div class="dropzone-custom-content">
                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                <h4>{{this.$t('documents.AddEdit.FilepathNote')}}</h4>
              </div>
            </vue2Dropzone>
            </b-form-group>
            </div>          
          </div>
          <br>


          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table mb-0">
                           
               <tr  v-for="(src, index) in files" :key="index" ><td width="10">
                 <i v-if="src.file_type=='pdf'" class="fas fa-file-pdf fa-lg" style="color:red"></i>
                  <i v-if="src.file_type=='xls' || src.file_type=='xlsx'" class="fas fa-file-excel fa-lg" style="color:black"></i>
                  <i v-if="src.file_type=='doc' || src.file_type=='docx'" class="fas fa-file-word fa-lg" style="color:gray"></i>
                  <i v-if="src.file_type=='ppt' || src.file_type=='pptx'"  class="fas fa-file-powerpoint fa-lg" style="color:green"></i>
                  <i v-if="src.file_type=='png' || src.file_type=='jpeg' || src.file_type=='jpg' || src.file_type=='gif' 
                  || src.file_type=='tif'" class="fas fa-file-image fa-lg" style="color:blue"></i>
                  <i v-if="src.file_type=='mp3' || src.file_type=='wav' || src.file_type=='wma'"
                   class="fas fa-file-audio fa-lg" style="color:black"></i>
                  <i v-if="src.file_type=='zip' || src.file_type=='rar'"  class="fas fa-file-archive fa-lg" style="color:orange"></i>
                  <i v-if="src.file_type=='mp4' || src.file_type=='avi' || src.file_type=='wmv' 
                  || src.file_type=='mow' || src.file_type=='webm' || src.file_type=='mkv' 
                  || src.file_type=='flv' || src.file_type=='mpeg' || src.file_type=='3gp' 
                  || src.file_type=='mpg' || src.file_type=='m4p' " 
                  class="fas fa-file-image fa-lg" style="color:yellow"></i>
               </td><td>{{src.file_name}}</td>
               <td>  <b-button-group>
                  <b-button variant="danger" @click="dosya_sil(index)"><i class="far fa-trash-alt"></i></b-button>
                  </b-button-group>
                 </td></tr> 
              </table>

              </div>
            </div>
          </div>


            <br>
            <br>

  
 
        <button class="btn btn-primary" type="submit">
          {{ $t("documents.AddEdit.Button") }}
        </button>
      </Form>



    </b-modal>
  </Loader>
</template>
